export var EventType;
(function (EventType) {
    EventType["CLICK"] = "click";
    EventType["MOUSE_MOVE"] = "mouse_move";
    EventType["SCROLL"] = "scroll";
    EventType["DOM_LOAD"] = "dom_load";
    EventType["DOM_UNLOAD"] = "dom_unload";
})(EventType || (EventType = {}));
export var ScrollDirection;
(function (ScrollDirection) {
    ScrollDirection["UP"] = "up";
    ScrollDirection["DOWN"] = "down";
})(ScrollDirection || (ScrollDirection = {}));
